module.exports = __webpack_public_path__ + "static/media/tiny_face_detector_model.2e48b209.bin";